import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import {Toaster} from "react-hot-toast";
import {notify} from "../../utils";
import {changeToPaid, deleteDiscountCode, doneEkyc, resetEkyc} from "../../../api/LeaderPortalApi";
import {positiveNotify} from "../../utils/Notify";
import {useState} from "react";

export const EkycDonePopUp = ({open, setOpen, id, setLoadingPage}) => {
    const [isLoading, setIsLoading] = useState(false)

    const style = (theme) => ({
        position: 'absolute',
        top: '50%',
        left: '50%',
        padding:0,
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: '10px',
        width:'300px'
    })

    const onSubmit = () => {
        setIsLoading(true)
        doneEkyc(id).then(response => {
            setLoadingPage(prev => !prev)
            setIsLoading(false)
            positiveNotify("احراز هویت تصویری با موفقیت تایید شد.")
            setOpen(false)
        }).catch(error => {
            setIsLoading(false)
            notify(error?.response?.data?.message)
        })

    }

    return(
        <Modal
            open={open}
        >
            <Box sx={style } className="rule-width px-4">
                <p className={`text-center mt-4 mx-4 text-justify`}></p>تایید شما به منزله این است که صحت زنده بودن کاربر، تطابق چهره کاربر با عکس کارت ملی و مشخصات درج شده در پنل توسط شما بررسی شده است. ایا از تایید خود مطمئن هستید و موارد لازم را بررسی کرده اید؟

                <div className={`row mx-2 my-4 justify-content-between`}>
                    <button
                        className={`col-4 btn border px-2`}
                        style={{fontWeight: "600"}}
                        onClick={() => setOpen(false)}
                    >انصراف</button>
                    <button className={`col-7 btn btn_discount py-2 p-0`} onClick={onSubmit}>تایید احراز هویت</button>
                </div>

                {isLoading && (
                    <div className="loading-overlay">
                        <div className="loading-content">
                            <div className="spinner"></div>
                            <p className='loader-text mt-3'>لطفا چند لحظه منتظر بمانید</p>
                        </div>
                    </div>
                )}
            </Box>
        </Modal>
    )
}

export const ChangeTransactionStatusPaid = ({open, setOpen, id, setLoadingPage}) => {
    const [isLoading, setIsLoading] = useState(false)

    const style = (theme) => ({
        position: 'absolute',
        top: '50%',
        left: '50%',
        padding:0,
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: '10px',
        width:'300px'
    })

    const onSubmit = () => {
        setIsLoading(true)
        changeToPaid(id).then(response => {
            setLoadingPage(prev => !prev)
            setIsLoading(false)
            positiveNotify("تغییر وضعیت با موفقیت انجام شد.")
            setOpen(false)
        }).catch(error => {
            setIsLoading(false)
            notify(error?.response?.data?.message)
        })

    }

    return(
        <Modal
            open={open}
        >
            <Box sx={style } className="rule-width p-0">
                <p className={`text-center mt-4 px-4 text-justify`}>در صورت تایید اگر گواهی حقوقی باشد کاربر به صفحه تکمیل اطلاعات شرکت میرود و اگر حقیقی باشد به صفحه تکمیل اطلاعات فردی هدایت میشود. ایا از تایید این تغییر وضعیت مطمئن هستید؟</p>

                <div className={`row mx-5 my-4 justify-content-between`}>
                    <button
                        className={`col-4 btn border px-2`}
                        style={{fontWeight: "600"}}
                        onClick={() => setOpen(false)}
                    >انصراف</button>
                    <button className={`col-7 btn btn_discount py-2 p-0`} onClick={onSubmit}>تایید </button>
                </div>

                {isLoading && (
                    <div className="loading-overlay">
                        <div className="loading-content">
                            <div className="spinner"></div>
                            <p className='loader-text mt-3'>لطفا چند لحظه منتظر بمانید</p>
                        </div>
                    </div>
                )}
            </Box>
        </Modal>
    )
}

export const EkycDoneReset = ({open, setOpen, id, setLoadingPage}) => {
    const [isLoading, setIsLoading] = useState(false)

    const style = (theme) => ({
        position: 'absolute',
        top: '50%',
        left: '50%',
        padding:0,
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: '10px',
        width:'300px'
    })

    const onSubmit = () => {
        setIsLoading(true)
        resetEkyc(id).then(response => {
            setLoadingPage(prev => !prev)
            setIsLoading(false)
            positiveNotify("احراز هویت تصویری با موفقیت به روز شد.")
            setOpen(false)
        }).catch(error => {
            setIsLoading(false)
            notify(error?.response?.data?.message)
        })

    }

    return(
        <Modal
            open={open}
        >
            <Box sx={style } className="rule-width px-4">
                <p className={`text-center mt-4 mx-4 text-justify`}>کاربر تاکنون 10 بار برای احرازهویت تلاش کرده و ناموفق بوده است. در صورت تایید شما امکان احرازهویت مجدد به کاربر داده میشود. لطفا قبل از تایید از اینکه کاربر کاملا برای احرازهویت صحیح تفهیم شده است مطمئن شوید. آیا تایید میکنید؟</p>
                <div className={`row mx-2 my-4 justify-content-between`}>
                    <button
                        className={`col-4 btn border px-2`}
                        style={{fontWeight: "600"}}
                        onClick={() => setOpen(false)}
                    >انصراف</button>
                    <button className={`col-7 btn btn_discount py-2 p-0`} onClick={onSubmit}>تایید</button>
                </div>

                {isLoading && (
                    <div className="loading-overlay">
                        <div className="loading-content">
                            <div className="spinner"></div>
                            <p className='loader-text mt-3'>لطفا چند لحظه منتظر بمانید</p>
                        </div>
                    </div>
                )}
            </Box>
        </Modal>
    )
}